module.exports = __webpack_public_path__ + "static/media/AB_A6_1.9519cd00.jpg";